module.exports = __webpack_public_path__ + "assets/img/flow1.d53fe07e.png";